import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import getLikeLabel from 'utils/i18n/getLikeLabel';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import { TooltipPill, TooltipPillWithCount } from 'components/Pill';
function InfoIcons(props) {
  var isSaved = props.isSaved,
    visibility = props.visibility,
    commentCount = props.commentCount,
    commentCountUser = props.commentCountUser,
    hasUserLiked = props.hasUserLiked,
    likeCount = props.likeCount,
    isOptional = props.isOptional,
    playlistName = props.playlistName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(InlineList.Wrapper, {
    spacing: "xs",
    align: "top"
  }, isOptional && /*#__PURE__*/React.createElement(InlineList.Item, null, /*#__PURE__*/React.createElement(TooltipPill, {
    title: t('content_status_optional_info', {
      playlistName: playlistName
    })
  }, t('content_status_optional'))), likeCount > 0 && /*#__PURE__*/React.createElement(InlineList.Item, null, /*#__PURE__*/React.createElement(TooltipPillWithCount, {
    title: getLikeLabel(likeCount, hasUserLiked),
    icon: "like",
    count: likeCount,
    highlightIcon: hasUserLiked
  })), config.enableComments && commentCount > 0 && /*#__PURE__*/React.createElement(InlineList.Item, null, /*#__PURE__*/React.createElement(TooltipPillWithCount, {
    title: t('comment_count', {
      count: commentCount
    }),
    icon: "chat",
    count: commentCount,
    highlightIcon: commentCountUser > 0
  })), Boolean(isSaved) && /*#__PURE__*/React.createElement(InlineList.Item, null, /*#__PURE__*/React.createElement(TooltipPill, {
    title: t('actions_saved_for_later')
  }, /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    dimmed: true,
    name: "favourite",
    scale: 0
  }))), Boolean(visibility) && /*#__PURE__*/React.createElement(InlineList.Item, null, /*#__PURE__*/React.createElement(TooltipPill, {
    title: visibility === 'private' ? t('only_admins_can_see_this') : t('content_currently_not_available')
  }, /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    dimmed: true,
    name: "eye-closed",
    scale: 0
  }))));
}
export default InfoIcons;